<!--
    Summary:
        hkml.exhibition.web - p8-attention
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-p8-attention" title="p8-attention">
    <div class="content">
      <div class="left">
        <div class="left-content">
          <h2>{{$t('YDnaTest.p8_title')}}</h2>
          <p>{{$t('YDnaTest.p8_1_1')}}</p>
          <p>{{$t('YDnaTest.p8_1_2')}}</p>
        </div>
      </div>

      <div class="right">
        <p>{{$t('YDnaTest.p8_2_1')}}</p>
        <p>{{$t('YDnaTest.p8_2_2')}}</p>
        <p>{{$t('YDnaTest.p8_2_3')}}</p>
        <p>{{$t('YDnaTest.p8_2_4')}}</p>
        <p>{{$t('YDnaTest.p8_2_5')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "p8-attention"
  }
</script>

<style scoped lang="scss">
  .en .v-p8-attention {
    .content {
      .left{
        .left-content{
          width: 23vw;
        }
      }
      .right {
        font-size: 1vw;
      }
    }
  }
</style>
<style scoped lang="scss">
  .v-p8-attention {
    text-align: left;

    padding: 0 0 3vw;

    p {
      margin-bottom: .3vw;
    }

    .content {
      display: flex;
      justify-content: center;

      .left {
        width: 50%;
        position: relative;
        padding-right: 3.7vw;
        display: flex;
        justify-content: flex-end;

        .left-content{
          width: 21vw;

          h2 {
            color: #273163;
            font-size: 2.6vw;
            font-weight: bold;
            margin-bottom: 1vw;
          }

          p {
            font-size: 1.3vw;
            line-height: 1.4;
          }
        }

        &:after {
          content: ' ';
          position: absolute;
          top: 0;
          right: -1px;
          width: 3px;
          height: 100%;
          background: #36486e;
        }
      }

      .right {
        width: 50%;
        padding-left: 2.5vw;

        p {
          font-size: 1.3vw;
          line-height: 1.4;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/p8-attention.vue